export default __webpack_public_path__ + "static/media/base_logo.10d9e192.svg";